var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_296_4296",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.005 24.01C14.4505 24.0119 15.8821 23.7281 17.2175 23.1749C18.5529 22.6217 19.7659 21.8101 20.7866 20.7866C21.8101 19.7659 22.6217 18.5529 23.1749 17.2175C23.7281 15.8821 24.0119 14.4505 24.01 13.005C24.0118 11.5595 23.728 10.128 23.1749 8.79253C22.6217 7.4571 21.8101 6.24414 20.7866 5.22337C19.7659 4.19992 18.5529 3.38829 17.2175 2.83512C15.8821 2.28194 14.4505 1.99814 13.005 2.00001C11.5595 1.99817 10.128 2.28199 8.79253 2.83516C7.4571 3.38833 6.24414 4.19995 5.22337 5.22337C4.19995 6.24414 3.38833 7.4571 2.83516 8.79253C2.28199 10.128 1.99817 11.5595 2.00001 13.005C1.99814 14.4505 2.28194 15.8821 2.83512 17.2175C3.38829 18.5529 4.19992 19.7659 5.22337 20.7866C6.24414 21.8101 7.4571 22.6217 8.79253 23.1749C10.128 23.728 11.5595 24.0118 13.005 24.01Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60303 13.0046L11.9045 16.3061L18.5075 9.70312",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_296_4296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.201172 -0.201172H26.2108V26.2108H-0.201172V-0.201172Z",
    fill: "#EF233C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.f2dea4ae11b3be68336cb256626e5e83.svg";
export { ForwardRef as ReactComponent };